import { render, staticRenderFns } from "./WarehouseReturnSelectorForm.vue?vue&type=template&id=6e3ae80d&"
import script from "./WarehouseReturnSelectorForm.vue?vue&type=script&lang=js&"
export * from "./WarehouseReturnSelectorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormSelect} from 'bootstrap-vue'
    installComponents(component, {BFormSelect})
    

export default component.exports